module.exports = __webpack_public_path__ + "static/media/icon_kinmukeitai.c5ae182f.svg";